// import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { changeTab } from '../../../../Features/reportAnalysisSlice';
import { useNavigate } from 'react-router-dom';
// import { randomHexColorWithArray } from 'random-hex-color-generator';

function CouponPerformanceGraph({ couponData }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // const total = couponData.reduce((prev, curr) => prev + curr.value, 0);

    // const [sortedPieData, setSortedPieData] = useState([]);
    // const [colors, setColors] = useState([]);

    // useEffect(() => {
    //     const colorsArray = randomHexColorWithArray(couponData.length);
    //     setColors(colorsArray);

    //     setSortedPieData(couponData.sort((a,b) => b.value - a.value));
    // }, [couponData]);

    // const dimensions = {
    //     innerRadius: 65,
    //     outerRadius: 100,
    // }

    // const [graphDimensions, setGraphDimensions] = useState(dimensions);
    // const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setWindowWidth(window.innerWidth);
    //     };

    //     window.addEventListener('resize', handleResize);

    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);

    // useEffect(() => {
    //     if (windowWidth < 1153) {
    //         if(windowWidth < 1081) {
    //             setGraphDimensions({
    //                 innerRadius: 55,
    //                 outerRadius: 80,
    //             });
    //         }
    //         else {
    //             setGraphDimensions({
    //                 innerRadius: 60, 
    //                 outerRadius: 90,
    //             });
    //         }
    //     }
    // }, [windowWidth]);

    const handleButtonClick = () => {
        dispatch(changeTab('coupons'));
        navigate('/report-and-analytics');
    }

    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-1 min-h-[50vh] p-5 flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <h1 className="font-semibold text-base">Coupon Performance</h1>

                <button onClick={handleButtonClick} className="p-0 outline-none border-none text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all data</button>
            </div>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            {/* <ResponsiveContainer className='relative' width="100%" height="70%">
                <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[10px] text-black'>
                    <div className='flex flex-col items-center gap-2'>
                        <div className="flex gap-2 items-center">
                            <div className='rounded size-3' style={{ backgroundColor: colors[0%colors.length] }}></div>

                            <h2 className='text-[12px] leading-5 font-semibold text-[#666666]'>{sortedPieData[0]?.name}</h2>
                        </div>

                        {
                            sortedPieData[0]?.value && total > 0 ? (
                                <h2 className="text-[16px] leading-5 font-semibold">
                                {((sortedPieData[0].value / total) * 100).toFixed(0)}%
                                </h2>
                            ) : (
                                <h2 className="text-[16px] leading-5 font-semibold">0%</h2>
                            )
                        }
                    </div>
                </div>

                <PieChart>
                    <Pie
                        data={couponData}
                        innerRadius={graphDimensions.innerRadius}
                        outerRadius={graphDimensions.outerRadius}
                        fill="#8884d8"
                        paddingAngle={0}
                        dataKey="value" 
                    >
                        {couponData.map((_, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                    </Pie>

                    <Tooltip content={<></>} />
                </PieChart>
            </ResponsiveContainer> */}

            {/* <div className="grid grid-cols-2 grid-rows-2 gap-x-16 max-[1280px]:gap-x-8 max-[1152px]:gap-x-6 gap-y-4">
                {sortedPieData.slice(1).map((item, index) => {
                    const newColorList = colors.slice(1);
                    const color = newColorList[index % newColorList.length];
                    const percentage = (item.value/total)*100;

                    return (
                        <div className='flex w-full gap-2 items-center justify-between' key={index}>
                            <div className="flex gap-2 items-center">
                                <div className='rounded size-3' style={{ backgroundColor: color }}></div>

                                <h2 className='text-[12px] max-[1152px]:text-[10px] leading-5 max-[1152px]:leading-4 font-semibold text-[#666666]'>{item.name}</h2>
                            </div>

                            <h2 className="text-[12px] max-[1152px]:text-[10px] leading-5 max-[1152px]:leading-4 font-semibold">{percentage.toFixed(0)}%</h2>
                        </div>
                    )
                })}
            </div> */}
        </div>
    );
}

export default CouponPerformanceGraph;
